let apiPrefixUrl = 'https://patient.kfsyscc.org/normal_api/service'

if(process.env.REACT_APP_ENV === "TEST"){
    apiPrefixUrl = 'http://172.21.42.11:8000/normal_api/service'
}

export {
    apiPrefixUrl
}